import { UseExternalRPCQueryOptions, useRPCQuery } from '@/lib/api/request/use-rpc-query';

import { LegalDocumentItem } from './use-legal-documents';

type GetConsentStatusRequest = Record<string, never>;

export type GetConsentStatusResponse = {
  required: boolean;
  documents: LegalDocumentItem[];
  documentVersions: Record<string, string>;
};

export function useGetConsentStatus({
  params,
  ...opts
}: UseExternalRPCQueryOptions<GetConsentStatusResponse, GetConsentStatusRequest>) {
  return useRPCQuery({
    ...opts,
    queryKey: ['consent-status', 'ignoreLoading'],
    method: useGetConsentStatus.method,
    params,
    staleTime: 0,
  });
}

useGetConsentStatus.method = 'user:get-consent-status';
